export default "__VITE_ASSET__C3Ia4g5$__"